import React, { useState } from 'react';
import { FormattedMessage, injectIntl } from 'react-intl';
import {
  Grid,
  Checkbox,
  Button,
  Modal,
} from '../../canvasComponents/index';
// scss
import '../../css/components/PopUps/PopUps.scss';
// messages
import messages from './messages';

function ConsentPopUp({ agreeConsentPopUp, open, closeConsentPopUp }) {
  const [checked, setChecked] = useState(false);
  const [checkedPp, setCheckedPp] = useState(false);
  const [error, setError] = useState(false);
  const [errorPp, setErrorPp] = useState(false);

  const redirectToClaim = () => {
    if (checked && checkedPp) {
      agreeConsentPopUp();
    } else if (!checked && checkedPp) {
      setError(true);
    } else if (checked && !checkedPp) {
      setErrorPp(true);
    } else {
      setErrorPp(true);
      setError(true);
    }
  };

  return (
    <Modal
      ariaHideApp={false}
      id="consent_modal"
      isOpen={open}
      onRequestClose={() => {
        setChecked(false);
        setCheckedPp(false);
        closeConsentPopUp();
      }}
    >
      <div className="modal-grid">
        <Grid>
          <div className="pop-up-title">
            <FormattedMessage {...messages.title} />
          </div>
          <div>
            <div className="pop-up-subtitle">
              <FormattedMessage {...messages.getFamiliarSubtitle} />
            </div>
            <div className="pop-up-text">
              <ul className="pop-up-list">
                <li>
                  <span>
                    <FormattedMessage {...messages.getFamiliar1} />
                  </span>
                </li>
                <li>
                  <FormattedMessage {...messages.getFamiliar2} />
                </li>
                <li>
                  <FormattedMessage {...messages.getFamiliar3} />
                </li>
                <li>
                  <FormattedMessage {...messages.getFamiliar4} />
                </li>
                <li>
                  <FormattedMessage {...messages.getFamiliar5} />
                </li>
              </ul>
            </div>
            <div className="pop-up-subtitle">
              <FormattedMessage {...messages.otherTipsSubtitle} />
            </div>
            <div className="pop-up-text">
              <ul className="pop-up-list">
                <li>
                  <FormattedMessage {...messages.otherTips1} />
                </li>
                <li>
                  <FormattedMessage {...messages.otherTips2} />
                </li>
                <li>
                  <FormattedMessage {...messages.otherTips3} />
                </li>
                <li>
                  <FormattedMessage {...messages.otherTips4} />
                </li>
              </ul>
            </div>
          </div>
          <Grid className="checkbox-grid">
            <Grid.Row>
              <div className="checkbox-container">
                <Checkbox
                  className="consent-checkbox"
                  primary
                  checked={checked}
                  onChange={() => {
                    setChecked(!checked);
                    setError(false);
                  }}
                >
                  <div className="checkbox-text">
                    <FormattedMessage {...messages.checkbox} />
                  </div>
                </Checkbox>
              </div>
            </Grid.Row>
            {error && (
              <Grid.Row>
                <span style={{ display: 'list-inline' }} className="error-text">
                  <FormattedMessage {...messages.error} />
                </span>
              </Grid.Row>
            )}
            <Grid.Row>
              <div className="checkbox-container">
                <Checkbox
                  className="consent-checkbox"
                  primary
                  checked={checkedPp}
                  onChange={() => {
                    setCheckedPp(!checkedPp);
                    setErrorPp(false);
                  }}
                >
                  <div className="checkbox-text">
                    <FormattedMessage {...messages.checkbox2} />
                  </div>
                </Checkbox>
              </div>
            </Grid.Row>
            {errorPp && (
              <Grid.Row>
                <span style={{ display: 'list-inline' }} className="error-text">
                  <FormattedMessage {...messages.error} />
                </span>
              </Grid.Row>
            )}
            <Grid.Row justifyContentCenter flex>
              <Button primary className="pop-up-btn" onClick={() => redirectToClaim()}>
                <FormattedMessage {...messages.button} />
              </Button>
            </Grid.Row>
          </Grid>
        </Grid>
      </div>
    </Modal>
  );
}

export default injectIntl(ConsentPopUp);
